
import React, { useState, useEffect } from 'react';
import { Row, Col, Dropdown, Button } from 'react-bootstrap';
import { deletePlayerDescription, getPlayerDescriptions, updateActivePlayerDescription, updateCharacterBiography, updatePlayerDescription } from '../../components/deityRequests';
import PlayerDescriptionEntry from './PlayerDescriptionEntry';
import PlayerCurrentDescription from './PlayerCurrentDescription';
import PlayerDescriptionCreate from './PlayerDescriptionCreate';

export const descriptionTypes = ["Short", "Long", "Body"];

const PlayerDescriptionEditor = ({ match, extraParams }) => {
    let defaultPlayer = localStorage.getItem('currentUser');

    const [playerName, setPlayerName] = useState(defaultPlayer);
    const [activeDescription, setActiveDescription] = useState('');
    const [currentDescription, setCurrentDescription] = useState('');
    const [descriptionType, setDescriptionType] = useState(0);
    const [playerData, setPlayerData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);

    const getPlayerDescriptionData = async () => {
        const data = await getPlayerDescriptions(playerName, descriptionTypes[descriptionType].toLowerCase());
        if (data.result) {
            setPlayerData(data.descriptions);
            setActiveDescription(data.activeDescription);
            setCurrentDescription(data.currentDescription);
        } else {
            setPlayerData([]);
            setActiveDescription('');
            setCurrentDescription('');
        }
    }

    useEffect(() => {
        getPlayerDescriptionData();
    }, [descriptionType]);


    const updateEntry = async (entry) => {
        const data = await updatePlayerDescription(playerName, descriptionTypes[descriptionType].toLowerCase(), entry);
        if (data.result) {
            if (data.message !== undefined) {
                window.alert(data.message);
            }
            getPlayerDescriptionData();
        } else {
            if (data.message !== undefined) {
                window.alert(data.message);
            }
            setPlayerData([]);
            setActiveDescription('');
            setCurrentDescription('');
        }
    }

    const deleteEntry = async (entry) => {
        const data = await deletePlayerDescription(playerName, descriptionTypes[descriptionType].toLowerCase(), entry);
        if (data.result) {
            getPlayerDescriptionData();
        } else {
            setPlayerData([]);
            setActiveDescription('');
            setCurrentDescription('');
        }
    }

    const selectActiveDescription = async (code) => {
        const data = await updateActivePlayerDescription(playerName, descriptionTypes[descriptionType].toLowerCase(), code);
        if (data.result) {
            getPlayerDescriptionData();
        } else {
            setPlayerData([]);
            setActiveDescription('');
            setCurrentDescription('');
        }
    }

    const createDescription = (descriptionId, description) => {
        let newDescription = {};
        newDescription.descriptionType = descriptionType;
        newDescription.descriptionId = descriptionId;
        newDescription.descriptionValue = description;

        updateEntry(newDescription);
        setShowCreate(false);
    }

    return <div className="container px-2">
        <PlayerDescriptionCreate showModal={showCreate} hideModal={() => setShowCreate(false)} createDescription={createDescription} descriptionType={descriptionType} />
        <Row className={"row-centered"}>
            <Col lg={1}>
                <Button onClick={() => setShowCreate(true)}>Create</Button>
            </Col>
            <Col lg={2}>
                <Dropdown >
                    <Dropdown.Toggle variant="tool" id="dropdown-basic">
                        {descriptionTypes[descriptionType]}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setDescriptionType(0)}>Short</Dropdown.Item>
                        <Dropdown.Item onClick={() => setDescriptionType(1)}>Long</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>

            </Col>
            <Col>
                <h1>
                    Descriptions for {playerName}</h1>
            </Col>
        </Row>
        <Row>
            <PlayerCurrentDescription descriptionType={descriptionType} defaultUsername={playerName} activeDescriptionCode={activeDescription} currentDescription={currentDescription} descriptions={playerData} selectActiveDescription={selectActiveDescription} />
        </Row>
        {playerData.sort((a, b) => a.descriptionId > b.descriptionId ? 1 : -1).map((description, index) =>
            <PlayerDescriptionEntry key={index} descriptionType={descriptionType} defaultUsername={playerName} descriptionEntry={description} updateEntry={updateEntry} deleteEntry={deleteEntry} selectActiveDescription={selectActiveDescription} />
        )}

    </div>
}

export default PlayerDescriptionEditor;